import { Type } from "class-transformer";
import { EnaioObjectId } from "src/modules/enaio/shared/EnaioObjectId";
import { GenericDataType } from "src/modules/enaio/shared/GenericDataType";
import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";
import { Utils } from "src/modules/utils/shared/utils";
import { DataSourceItem } from "./data-source-item.model";

export class EnaioDataSource {
    id = "";
    inputParams: OrdinaryObject<GenericDataType> = {};
    @Type(() => EnaioObjectId)
    keyFields: EnaioObjectId[] = [];
    backendOnly = false;

    getKey(o: DataSourceItem): string {
        return Utils.arrayItemsToString(this.keyFields, "|||", kf => Utils.toString(o.data[kf.internalName]));
    }
}